import React, { FC } from "react";

import { HeroBanner } from "../../strips/hero-banner";
import { HeroBannerVariants, JustifyText } from "../../strips/hero-banner/types";
import { useEventDetail } from "../event-detail/event-detail-context";
import { materialsMap } from "../materials-map";
import { EventHeroCard } from "./event-hero-card";

export interface EventHeroBannerProps {
  onScrollToVideo: () => void;
}

export const EventHeroBanner: FC<EventHeroBannerProps> = ({ onScrollToVideo }) => {
  const { event, labels } = useEventDetail();

  return (
    <HeroBanner
      color={null}
      showBiesseLogo={false}
      padded={false}
      title={event?.title ?? ""}
      tagVariant={HeroBannerVariants.h1}
      justifyText={JustifyText.LEFT}
      abstract={null}
      media={null}
      backgroundImageUrl={event?.urlImg}
      className="!max-h-max !bg-dark"
      pillTags={(event?.materials ?? []).map(({ Name }) => {
        const materialData = materialsMap[Name];
        return {
          color: materialData?.tagColor,
          children: labels[materialData?.label] ?? Name,
        };
      })}
      card={null}
      anchors={null}
      customCard={event && <EventHeroCard onScrollToVideo={onScrollToVideo} className="max-w-xl" />}
    />
  );
};
